// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"dashboard_pageSection__oCBQm","pageTitle":"dashboard_pageTitle__1VhMi"};